module.exports = __webpack_public_path__ + "img/fondo-banner-principal.d5f9940e.svg";